import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import PageContainer from 'components/Containers/PageContainer';
import { Row } from 'components/Containers/Row/Row';
import { DEBT_RELIEF_ACTION } from 'types/morph.pagePosition.constants';
import { DEBT_RELIEF } from 'partial/OfferManager/module.constants';

import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';

import Label from 'components/form/Label/Label';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const DebtReliefView = props => {
  const defaultTestId = 'DebtReliefView';

  return (
    <PageContainer datatestid={defaultTestId}>
      {props.seenPixel}
      <Disclaimer
        showPartnerText
        datatestid={'DebtRelief'}
        className={'margb8 m-marglr8'}
      />
      <SectionContainer datatestid={`debtReliefOffer`}>
        <Row>
          <Label
            type="H3"
            typeHeader={'h3'}
            className="margB32"
            datatestid={`${defaultTestId}-title`}
          >
            {props.heading}
          </Label>
          <StaticOfferContainer
            modulePosition={props.modulePosition}
            eventHandler={props.eventHandler}
            module={DEBT_RELIEF}
            pagePosition={DEBT_RELIEF_ACTION}
            offerMetadataList={props.offers}
            {...props}
          />
        </Row>
      </SectionContainer>
    </PageContainer>
  );
};

export default DebtReliefView;
